<div class="flex flex-row justify-between">
  <div class="flex flex-row items-center">
    <p-breadcrumb
      [model]="[{ label: this.kategorie ?? undefined }, { label: 'KI Korrektur Prompts' }]"
      [home]="{ label: 'Kategorien', routerLink: '/kategorien' }"
      />
  </div>
</div>

<h3 class="mt-3">KI Korrektur Prompts</h3>

@if (this.isLoading) {
  <div
    class="text-center py-4"
    >
    <p>Lädt Prompt-Vorlagen...</p>
  </div>
}

@if (!this.isLoading) {
  <p-table
    #dt
    showGridlines
    [value]="this.promptTemplates"
    [tableStyle]="{ 'min-width': '50rem' }"
    scrollable="true"
    scrollHeight="600px"
    class="mt-3"
    >
    <ng-template #header>
      <tr>
        <th class="w-[20%]">Name</th>
        <th class="w-[60%]">KI Korrektur Prompt</th>
        <th class="w-[10%]">Standard für</th>
        <th class="w-[10%]"></th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-template
      >
      <tr>
        <td>
          @if (this.isEditing(template._id)) {
            <input
              pInputText
              type="text"
              [(ngModel)]="template.name"
              class="w-full"
              />
          }
          @if (!this.isEditing(template._id)) {
            <span>
              {{ template.name }}
            </span>
          }
        </td>
        <td>
          @if (this.isEditing(template._id)) {
            <textarea
              rows="3"
              cols="30"
              pTextarea
              [(ngModel)]="template.prompt"
              fluid
            ></textarea>
          }
          @if (!this.isEditing(template._id)) {
            <span>
              {{ template.prompt | shorty: 150 }}
            </span>
          }
        </td>
        <td>
          @if (this.isEditing(template._id)) {
            <div class="flex flex-col gap-2">
              <div class="flex items-center gap-2">
                <p-checkbox
                  [value]="'standard'"
                  [(ngModel)]="template.selectedByDefault"
                  inputId="standard-{{template._id}}"
                  />
                <label for="standard-{{template._id}}">Standard</label>
              </div>
              <div class="flex items-center gap-2">
                <p-checkbox
                  [value]="'table'"
                  [(ngModel)]="template.selectedByDefault"
                  inputId="table-{{template._id}}"
                  />
                <label for="table-{{template._id}}">Tabelle</label>
              </div>
            </div>
          }
          @if (!this.isEditing(template._id)) {
            <div class="flex flex-col gap-1">
              @if (template.selectedByDefault?.includes('standard')) {
                <span class="text-green-600 text-sm">Standard</span>
              }
              @if (template.selectedByDefault?.includes('table')) {
                <span class="text-green-600 text-sm">Tabelle</span>
              }
              @if (!template.selectedByDefault?.length) {
                <span class="text-red-400 text-sm">—</span>
              }
            </div>
          }
        </td>
        <td>
          <div class="flex gap-2">
            @if (!this.isEditing(template._id)) {
              <i
                class="pi pi-pencil cursor-pointer"
                pTooltip="Bearbeiten"
                tooltipPosition="top"
                (click)="this.toggleEdit(template._id)"
                style="color: var(--p-blue-500)"
              ></i>
            }
            @if (this.isEditing(template._id)) {
              <i
                class="pi pi-check cursor-pointer"
                pTooltip="Speichern"
                tooltipPosition="top"
                (click)="this.savePromptTemplate(template); this.toggleEdit(template._id)"
                style="color: var(--p-green-500)"
              ></i>
            }
            @if (this.isEditing(template._id)) {
              <i
                class="pi pi-times cursor-pointer"
                pTooltip="Abbrechen"
                tooltipPosition="top"
                (click)="this.toggleEdit(template._id)"
                style="color: var(--p-orange-500)"
              ></i>
            }
            @if (!this.isEditing(template._id)) {
              <i
                class="pi pi-trash cursor-pointer"
                pTooltip="Löschen"
                tooltipPosition="top"
                (click)="this.deletePromptTemplate(template)"
                style="color: var(--p-red-500)"
              ></i>
            }
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #footer>
      <tr>
        <td colspan="4">
          <p-button
            icon="pi pi-plus"
            severity="secondary"
            label="KI Korrektur Prompt"
            (onClick)="this.addNewPromptTemplate()"
          ></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
}

<div class="p-4 bg-blue-50 border border-blue-200 rounded mb-4 mt-4">
  <h4 class="mt-0 mb-3">Verfügbare Platzhalter</h4>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
    @for (placeholder of this.placeholders; track placeholder) {
      <div
        class="flex items-start gap-2"
        >
        <span class="font-mono bg-white px-2 py-1 rounded border border-blue-300 text-sm">{{ placeholder }}</span>
      </div>
    }
  </div>
</div>

<p-confirmDialog></p-confirmDialog>